module.exports = __webpack_public_path__ + "static/gallery8-6e0a6d5a2f488e1ad385db87deaa00ad.png";